import API from './infrastructure/api/Api';
import Handler from './presenter/handler/Handler';
import MainUI from './presenter/ui/UI';
import Service from './usecase/Service';
import '../../../assets/styles/ORD/ORD006.css';
const ORD006Component = () => {
    const serverAPI = API();
    const service = Service(serverAPI);
    const handler = Handler(service);
    return <MainUI handler={handler} />;
};

export default ORD006Component;
